import { Button } from "./button";
import { motion } from "framer-motion";

const AnimatedButton = ({ children, primary, href, ...props }: { children: React.ReactNode; primary?: boolean, href: string }) => {
	return (
			<motion.a href={href} target="_blank" whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} className="relative">
				<Button
					size="lg"
					className={`w-full relative z-10 overflow-hidden font-medium ${
						primary 
							? "bg-gradient-to-r from-[#7371FF] to-[#6CD2E4] hover:from-[#6363F0] hover:to-[#5BC3D5] text-white" 
							: "bg-black outline-2 outline-[#7371FF] text-white hover:bg-black/90 bg-none"
					} rounded-xl px-8 py-4 shadow-md`}
					{...props}
				>
					<span className="relative z-10 flex items-center font-semibold text-lg">{children}</span>
					{primary && <motion.div className="absolute inset-0 bg-gradient-to-r from-[#6CD2E4] to-[#7371FF] opacity-0" whileHover={{ opacity: 1 }} transition={{ duration: 0.3 }} />}
				</Button>
				{primary && <div className="absolute -inset-0.5 bg-gradient-to-r from-[#6CD2E4]/50 to-[#7371FF]/50 opacity-30 blur-xl rounded-xl" />}
			</motion.a>
	);
};

export default AnimatedButton;